/**
 * Determines if the checkbox for contato principal should be disabled.
 * @param {string} valueContatoPrincipal - The value of contato principal.
 * @returns {boolean} - Returns true if the value is "S", indicating the checkbox should be disabled, otherwise false.
 */

export function isCheckboxDisabled(valueContatoPrincipal) {
  return valueContatoPrincipal === "S" ? true : false;
}
